<div class="flexi-container"
     [ngClass]="classes"
     [ngStyle]="{'justify-content' : justifyContent,  'padding': padding, 'flex-wrap': flexWrap, 'flex-direction' : flexDirection }">
     <!-- 'padding.rem': paddingRem, -->
  <ng-content></ng-content>
</div>